// removed by extract-text-webpack-plugin
module.exports = {"RegisterForm":"PHZpmzUSShL3M2LLUx_19","RegisterForm__fields":"_1fyGCayAT8f9yvTEc-tGzb","RegisterForm__input--email":"IKajp7cxIREHIBiUhlEx1","RegisterForm__input--password":"CfawAjQE09rSAplf8b008","RegisterForm__emailMessage":"_2J7hUA5UTIwRIX-t7lF33i","RegisterForm__action":"aZlmAML48c_7--lUilwvx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RegisterForm/RegisterForm.scss
// module id = 2720
// module chunks = 0